module.exports = __webpack_public_path__ + "img/blue-header.d6ef7bde.png";